import I18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import en from "./en";
import fr from "./fr";

I18n.use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: en
      },
      fr: {
        translation: fr
      }
    },
    detection: {
      // order and from where user language should be detected
      order: ["querystring", "cookie", "localStorage"],

      // keys or params to lookup language from
      lookupCookie: "i18next",
      lookupLocalStorage: "i18nextLng",

      // cache user language on
      caches: ["localStorage", "cookie"],
      excludeCacheFor: ["cimode"] // languages to not persist (cookie, localStorage)
    },
    fallbackLng: "en",
    debug: false,
    react: {
      wait: false,
      bindI18n: "languageChanged loaded",
      bindStore: "added removed",
      nsMode: "default"
    }
  });

export default I18n;
